export default "__VITE_ASSET__BCmQGWNv__"